import { MultiSelectDropdown } from '@platform/components';

import { Partners } from '@platform/client';
import { UseFormRegisterReturn } from 'react-hook-form';

type ImpactPartnerSelectionDropdownProps = {
  selectionLimit?: number;
  selectedImpactPartners: string[];
  onImpactPartnersSelectionChange: (selectedImpactPartners: string[]) => void;
  register?: () => UseFormRegisterReturn<string>;
  errors?: Record<string, { message: string } | undefined>;
  label: string;
};

export const ImpactPartnerSelectionDropdown = (props: ImpactPartnerSelectionDropdownProps) => {
  const {
    selectionLimit,
    selectedImpactPartners,
    onImpactPartnersSelectionChange,
    register,
    errors,
    label,
  } = props;

  const partners = Partners.useGetActiveImpactPartners().data || [];
  const partnerOptions = partners.map((partner) => ({
    label: partner.name,
    textValue: partner.id,
  }));

  return (
    <div className='w-[350px]'>
      <MultiSelectDropdown
        register={register}
        selectionLimit={selectionLimit}
        selectedItems={selectedImpactPartners}
        onSelectionChange={onImpactPartnersSelectionChange}
        options={partnerOptions}
        label={label ?? 'Select any impact partner affiliations'}
        placeholder='Select as many as apply'
        error={errors?.impactPartners?.message}
        filterable={true}
      />
    </div>
  );
};
